import { render, staticRenderFns } from "./table-page.vue?vue&type=template&id=fc3bb1ae&scoped=true"
import script from "./table-page.vue?vue&type=script&lang=js"
export * from "./table-page.vue?vue&type=script&lang=js"
import style0 from "./table-page.vue?vue&type=style&index=0&id=fc3bb1ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3bb1ae",
  null
  
)

export default component.exports